export const ADMIN_BASE_URL = window.location.origin;
